import { initializeApp } from 'firebase/app';
import {
  getAuth, connectAuthEmulator, setPersistence, browserSessionPersistence,
  multiFactor, TotpMultiFactorGenerator, getMultiFactorResolver,
  EmailAuthProvider, reauthenticateWithCredential, updatePassword
} from 'firebase/auth';
export {
  multiFactor, TotpMultiFactorGenerator, getMultiFactorResolver,
  EmailAuthProvider, reauthenticateWithCredential, updatePassword
};
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { logger } from '../utils/logger';

// Firebase configuration from environment variables
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Auth with session persistence
// Tokens stored in sessionStorage (cleared on browser/tab close) instead of
// IndexedDB (persists indefinitely). Forces re-login after browser close.
export const auth = getAuth(app);
setPersistence(auth, browserSessionPersistence);

// Get database ID from environment or fallback to default
const databaseId = import.meta.env.VITE_FIREBASE_DATABASE_ID || 'ccm-development';

// Initialize Firestore with CMEK database
export const db = getFirestore(app, databaseId);

// Environment configuration
const USE_EMULATOR = import.meta.env.VITE_USE_EMULATOR === 'true';
const USE_CMEK_DATABASE = import.meta.env.VITE_USE_CMEK_DATABASE === 'true';

logger.log('🔧 Firebase Configuration:', {
  useEmulator: USE_EMULATOR,
  useCMEKDatabase: USE_CMEK_DATABASE,
  environment: process.env.NODE_ENV,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  databaseId: databaseId
});

// Connect to emulators in development (only if enabled)
if (process.env.NODE_ENV === 'development' && USE_EMULATOR) {
  logger.log('🔧 Connecting to Firebase emulators...');
  
  // Connect to Auth emulator
  try {
    connectAuthEmulator(auth, 'http://127.0.0.1:9099');
    logger.log('✅ Connected to Auth emulator');
  } catch (error) {
    logger.log('ℹ️ Auth emulator already connected');
  }
  
  // Connect to Firestore emulator  
  try {
    connectFirestoreEmulator(db, '127.0.0.1', 8081);
    logger.log('✅ Connected to Firestore emulator');
  } catch (error) {
    logger.log('ℹ️ Firestore emulator already connected');
  }
} else if (USE_CMEK_DATABASE) {
  logger.log(`🔐 Using CMEK-enabled Firestore database: ${databaseId}`);
} else {
  logger.log('☁️ Using default Firebase configuration');
}

export default app;